/**
 * ============================================================================
 * useKnowledgePermissions — Guard de permissões para a Base de Conhecimento
 * ----------------------------------------------------------------------------
 * CHANGELOG:
 *   RELEASE: 2026-07-07 v1.0.0 - F1-Fix. Wrapper sobre usePermissions expondo
 *            flags kb_* usadas por rotas, sidebar e botões do módulo KB.
 * ============================================================================
 */
import { usePermissions } from "@/hooks/usePermissions";

// Retorna flags por operação do módulo KB. Admins do tenant e root_admin têm
// acesso total (regra já aplicada dentro do PermissionsContext).
export function useKnowledgePermissions() {
  const perms = usePermissions();

  // helper que respeita loading e role
  const can = (menuKey: string, action: "view" | "create" | "edit" | "delete" = "view") => {
    if (perms.loading) return false;
    if (perms.userRole === "root_admin" || perms.userRole === "tenant_admin") return true;
    const p = perms.permissions.find((m) => m.menu_key === menuKey);
    if (!p) return false;
    switch (action) {
      case "view": return !!p.can_view;
      case "create": return !!p.can_create;
      case "edit": return !!p.can_edit;
      case "delete": return !!p.can_delete;
    }
  };

  return {
    loading: perms.loading,
    canView: can("kb_view"),
    canCreate: can("kb_create"),
    canEdit: can("kb_edit"),
    canReview: can("kb_review"),
    canPublish: can("kb_publish"),
    isAdmin: can("kb_admin"),
    canManageClassification: can("kb_manage_classification"),
    canManageTaxonomies: can("kb_manage_taxonomies"),
  };
}
